import React, { useState } from "react";
import { Badge, Card, Dropdown } from "react-bootstrap";
import { Plus, QuestionCircle, X } from "react-bootstrap-icons";
import { AdminUserModel } from "../../models/AccountPermissionModel";
import { LanguageCode } from "../../constants/LanguageCode";
import localeHelp from "../../../assets/img/localeHelp.png";

interface IProps {
  num: number;
  edited: AdminUserModel;
  setEdited: React.Dispatch<React.SetStateAction<AdminUserModel>>;
}

const AddToggle = React.forwardRef<HTMLSpanElement, { onClick?: (e: React.MouseEvent) => void }>(
  ({ onClick }, ref) => (
    <Badge
      ref={ref}
      bg="primary"
      role="button"
      className="d-inline-flex align-items-center gap-1"
      style={{ cursor: "pointer", padding: "6px 10px" }}
      onClick={onClick}
    >
      <Plus size={13} />국가 추가
    </Badge>
  )
);
AddToggle.displayName = "AddToggle";

const AccountLocaleCard = ({ num, edited, setEdited }: IProps) => {
  const selectedLocales = edited.allowedLocales;
  const [isShowHelp, setIsShowHelp] = useState(false);
  const toggle = (id: string) =>
    setEdited((prev) => ({
      ...prev,
      allowedLocales: prev.allowedLocales.includes(id) ? prev.allowedLocales.filter((locale) => locale !== id) : [...new Set([...prev.allowedLocales, id])],
    }));
  const remaining = Object.values(LanguageCode).filter((id) => !selectedLocales.includes(id));

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="bg-white d-flex align-items-center gap-2">
        <Badge bg="primary" pill>{num}</Badge>
        <span className="fw-bold">국가</span>
        <span
          className="position-relative d-inline-flex align-items-center"
          onMouseEnter={() => setIsShowHelp(true)}
          onMouseLeave={() => setIsShowHelp(false)}
        >
          <QuestionCircle size={15} className="text-muted" role="button" />
          {isShowHelp && (
            <img
              src={localeHelp}
              alt="국가 코드 안내"
              className="position-absolute shadow border rounded bg-white"
              style={{ top: "100%", left: 0, marginTop: 6, width: 760, maxWidth: "90vw", height: "auto", zIndex: 1080 }}
            />
          )}
        </span>
        <span className="flex-grow-1" />
        <Badge bg="light" text="dark">{selectedLocales.length}개 적용</Badge>
      </Card.Header>
      <Card.Body className="d-flex flex-wrap gap-2 align-items-center">
        {selectedLocales.map((id) => (
          <Badge
            key={id}
            bg="primary"
            role="button"
            className="d-inline-flex align-items-center gap-1 font-monospace"
            style={{ cursor: "pointer", padding: "6px 10px" }}
            onClick={() => toggle(id)}
            title="클릭: 제거"
          >
            {id}<X size={13} />
          </Badge>
        ))}
        {selectedLocales.length === 0 && <span className="text-muted small">적용된 국가가 없습니다.</span>}

        <Dropdown>
          <Dropdown.Toggle as={AddToggle} />
          {/* renderOnMount: 메뉴를 미리 마운트해 popper 인스턴스를 첫 오픈 전에 생성 → 첫 클릭 시 좌상단(0,0) 깜빡임 방지 */}
          <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
            {remaining.length === 0 && <Dropdown.ItemText className="text-muted small">모든 국가가 적용됨</Dropdown.ItemText>}
            {remaining.map((id) => (
              <Dropdown.Item key={id} className="font-monospace" onClick={() => toggle(id)}>
                {id}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Body>
    </Card>
  );
};

export default AccountLocaleCard;
